import { get, apiCache } from '@/utils/request'
import { formatListTime } from '@/utils/tools'
import dayjs from 'dayjs'
import { getChannelDetail } from './channel'

export const getSwiperData = async () => {
  return await apiCache({
    url: 'article',
    method: 'get',
    data: { type: 'FOCUS', pageSize: 5, 'img-nnil': 'img' },
    cacheName: 'HomeFocusNews',
    cacheTime: 0.1
  })
}

export const getHomeTabNews = async () => {
  const params = { pageSize: 8, status: 'NORMAL' }
  const { list: news } = await apiCache({
    url: 'article',
    method: 'get',
    data: { ...params },
    cacheName: 'HomeTabNews',
    cacheTime: 0.1
  })
  const { list: notice } = await apiCache({
    url: 'article',
    method: 'get',
    data: { ...params, channel_id: 58 },
    cacheName: 'HomeTabNotice',
    cacheTime: 0.1
  })
  const { list: announcement } = await apiCache({
    url: 'article',
    method: 'get',
    data: { ...params, channel_id: 59 },
    cacheName: 'HomeTabAnnouncement',
    cacheTime: 0.1
  })
  return [
    {
      title: '滚动新闻',
      list: formatListTime(news)
    },
    {
      title: '民政要闻',
      list: formatListTime(notice)
    },
    {
      title: '通知公告',
      list: formatListTime(announcement)
    }
  ]
}

export const getHomeSectionNews = async () => {
  const ids = [41, 42, 60, 43, 45, 61, 50, 46, 47, 44, 48, 52]
  const res = {}
  for (const i of ids) {
    const channel = await getChannelDetail(i)
    const { list } = await apiCache({
      url: 'channel_article',
      method: 'get',
      data: { channel_id: i, status: 'NORMAL', pageSize: 5 },
      cacheName: `ChannelHomeNews-${i}`,
      cacheTime: 0.5
    })
    const { list: photoList } = await apiCache({
      url: 'channel_article',
      method: 'get',
      data: { channel_id: i, status: 'NORMAL', 'img-nnil': 'img', pageSize: 1 },
      cacheName: `ChannelHomePhotoNews-${i}`,
      cacheTime: 0.5
    })
    let photo = null
    if (photoList && photoList.length) {
      photo = photoList[0]
    }
    res[i] = { channel, list: formatListTime(list), photo }
  }
  return res
}

export const getArticleDetail = async (id) => {
  const { data } = await get(`article/${id}`)
  data.time = dayjs(data.time).format('YYYY-MM-DD')
  return data
}

export const getArticleList = async (param) => {
  const params = { status: 'NORMAL' }
  const { data } = await get('channel_article', { ...params, ...param })
  data.list = formatListTime(data.list)
  return data
}

export const getSingleDetail = async (id) => {
  const { data } = await get(`single/${id}`)
  return data
}
